<div class="edit-page-root-container category-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left"  > <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50"
                                        [readonly]="stockCategoryInfo.id!==undefined && stockCategoryInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Stock Category code should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field></div>

                            <div class="input-box-right"> <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Stock Category name should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field></div>

                        </div>

                      
                        <mat-checkbox [checked]="isSubCategory" formControlName="isSubCategory" (change)="toggleCategoryDropdown()">
                            Is Subcategory
                          </mat-checkbox>
                                                  <br />
                                                  <div>
                        <div class="input-group" style="display:flex;gap:10px;">
                            <div *ngIf="isSubCategory">
                                <mat-form-field  style="width:324px;">
                                    <mat-label>Category</mat-label>
                                    <mat-select formControlName="super_category_id" (selectionChange)="onCategoryChange($event.value)">
                                        <mat-option *ngFor="let category of superCategoryList" [value]="category.id">
                                            {{ category.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                             
                            </div>
                        
                        <div>
                            <div>
                        <mat-form-field>
                            <mat-label>Department</mat-label>
                            <mat-select formControlName="department_id"  [disabled]="isSubCategory" (selectionChange)="onDepartmentChange()">
                                <mat-option *ngFor="let dept of departmentList" [value]="dept.id">
                                    {{ dept.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                            </div>

                        </div>
                    </div>
                        </div>




                    </div>
                </div>







            </form>
        </div>
    </div>
</div>